import { useEffect, useState } from "react"
import useScreenSize from "./useScreenSize"

const useScroll = () => {
  const DESKTOP_SCROLLHEIGHT = 40
  const MOBILE_SCROLLHEIGHT = 20
  const TABLET_SCROLLHEIGHT = 10

  const [scroll, setScroll] = useState(false)
  const screen = useScreenSize()

  const scrollHeight = screen?.isDesktop
    ? DESKTOP_SCROLLHEIGHT
    : screen?.isMobile
    ? MOBILE_SCROLLHEIGHT
    : TABLET_SCROLLHEIGHT

  const handleScroll = () => setScroll(window.scrollY > scrollHeight)
  useEffect(() => {
    if (typeof window !== "undefined") {
      // Add event listener
      window.addEventListener("scroll", handleScroll)
      // Call handler right away so state gets updated with initial window height
      handleScroll()
      return () => {
        // Remove event listener on cleanup
        window.removeEventListener("scroll", handleScroll)
      }
    }
  }, [screen]) //  ensures that effect is only run on screen changes

  if (!scroll) {
    return { isScrolled: null }
  }
  return { isScrolled: scroll }
}
export default useScroll
